<section class="cst_body">
  <div class="container-fluid search_flt_box_main">
    <!-- need to write -->
    <form [formGroup]="searchForm" (ngSubmit)="search(searchForm)">
      <div class="search_flt_box">
      <div class="row">       

        <div class="col-2" *ngIf="tenantOrgInfo">
          <div class="form-group">
            <label for="formGroupExampleInput">Client Name</label> 
            <ng-select [items]="tenantsList" [multiple]="true"
             [closeOnSelect]="false" 
             [clearable]="true"
             (clear)="resetTeantFilters();"
            bindLabel="tenantName"
              bindValue="tenantCode" placeholder="Select Client" (click)="onTenantSelect()"
               formControlName="selectedTenant">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div class="ng-value" *ngFor="let item of items | slice:0:2">
                  <span class="ng-value-label"> {{item.tenantName}}</span>
                  <span class="ng-value-icon right" (click)="onTenantdeSelect(item);clear(item);" aria-hidden="true">×</span>
                </div>
                <div class="ng-value" *ngIf="items.length > 2">
                  <span class="ng-value-label">{{items.length - 2}} more...</span>
                </div>
              </ng-template>
            </ng-select>
        
          </div>
        </div>
        <div class="col-2" *ngIf="searchForm.controls['selectedTenant'].value">
          <div class="form-group">
            <label for="formGroupExampleInput">Client Organization</label> 
            
            <ng-select [items]="organizationsOfTenants" [multiple]="true"
             
            [closeOnSelect]="false" bindLabel="orgName"
              bindValue="orgCode" placeholder="Select Organization" (click)="onOrgSelect()" formControlName="selectedOrg">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div class="ng-value" *ngFor="let item of items | slice:0:2">
                  <span class="ng-value-label"> {{item.orgName}}</span>
                  <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </div>
                <div class="ng-value" *ngIf="items.length > 2">
                  <span class="ng-value-label">{{items.length - 2}} more...</span>
                </div>
              </ng-template>
            </ng-select>     
          </div>
        </div>

      <!-- </div>

        <div class="row"> -->
          
          <div class="col-{{dynamicSpan}}">
            <div class="row">
                <div class="col-2">
                <div class="form-group">
                  <label for="formGroupExampleInput">Search By Business</label>
                   <select id="inputState" class="form-control col-form-label-sm" formControlName="businessId">
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let businessoption of businessOptions" [value]="businessoption.value" >{{ businessoption.label }}</option>
                  </select> 
                </div>
              </div>
                <div class="col-2">
                <div class="form-group">
                  <label>Status</label>
                  <select id="inputState" class="form-control col-form-label-sm" formControlName="status" [(ngModel)]="selectedStatusValue">

                   
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let data of orderStatusList" [ngValue]="data.value">{{data.name}}</option>
                  </select>
                </div>
              </div>
			    <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Search By</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="searchBy">
                <!-- <option selected>Select</option> -->
                <!-- <option value="" [selected]="true">Select</option> -->
                <option [ngValue]="null" disabled>Select</option>
                <option>MRN</option>
                <option>Order ID</option>
                <option>Order Did</option>
              </select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Enter Value</label>
              <input type="text" class="form-control col-form-label-sm" formControlName="searchByValue"
                placeholder="Enter Value">
            </div>
          </div>
              <!--<div class="col-2">
                <div class="form-group">
                  <label>From Date</label>-->
                  <!-- (dateSelect)="onDateSelect($event)" -->
                  <!--<div class="input-group">
                    <input type="text" class="form-control" placeholder="yyyy-mm-dd" formControlName="startDate"
                      value="{{curDate | date:'yyyy-mm-dd'}}" name="dp" ngbDatepicker #fD="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
                          class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
  
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To Date</label>
                  <div class="input-group">
                    <input type="text" class="form-control" formControlName="endDate" placeholder="yyyy-mm-dd"
                      value="{{curDate | date:'yyyy-mm-dd'}}" name="dp" ngbDatepicker #tD="ngbDatepicker">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="tD.toggle()" type="button"><i
                          class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>-->
           
              <!--<div class="col-2">
                <div class="form-group">
                  <label for="formGroupExampleInput">Sort By Date</label>
                   <select id="inputState" class="form-control col-form-label-sm" formControlName="sortBy" [(ngModel)]="selectedValue" name="option">
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let option of options" [value]="option.value" [selected]="option.value === 'scheduled_date'" >{{ option.label }}</option>
                  </select> 
                </div>
              </div>-->

              <div class="col-2">
                <div class="form-group">
                  <label>Select Daterange:</label>
                  <div class="input-group">
                    <!--<input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker 
                    [bsValue]="bsRangeValue"
                    (bsValueChange)="onValueChange($event)"
                    [bsConfig]="{ rangeInputFormat : 'MM/DD/YYYY', showWeekNumbers: false }">-->
                    <input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker 
                    [bsValue]="bsRangeValue"
                    (bsValueChange)="onValueChange($event)" >
                    <div class="input-group-append">
                      <button class="btn btn-success" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" type="button"><i
                        class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              
                <!-- <div class="col-3 padLftRht6">
                <div class="form-group">
                  <label>Diagnostic Branch</label>
                  <select id="inputState" class="form-control col-form-label-sm" formControlName="diagnosticBranch">
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let data of diagnosticCenterList" [ngValue]="data.code">{{data.name}}</option>
                  </select>
                </div>
              </div>   -->

               <!--<div class="col-2 padLftRht6" *ngIf="isAllOrderSearch">
                <div class="form-group">
                  <label>Status</label>
                  <select id="inputState" class="form-control col-form-label-sm" formControlName="status">

                   
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let data of orderStatusList" [ngValue]="data.value">{{data.name}}</option>
                  </select>
                </div>
              </div> -->
              <div class="col-2 padLftRht6">
                <!-- <a href="#" class="green_btn" href="javascript:;"  (click) = "search()" >Search</a> -->
                <button type="submit" class="btn green_btn">Search</button>&nbsp;
                <button  class="btn green_btn" (click)="clear()">Clear</button>
              </div>

              <!-- <div class="col-2 padLftRht6">
                <button  class="btn green_btn" (click)="clear()">Clear</button>
               
              </div> -->
               
            </div>
          </div>

        </div>
      </div>
      <!-- need to close -->
    </form>
  </div>
  <div class="container-fluid" role="main" >
    <div class="table_main tableShadow">
      <!--<div class="tbl_name">
        All Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>-->
      <table class="table table-striped table-responsive">
        <thead >
          <tr class="tbl_name">
            <th>MRN</th>
            <th>Customer Name</th>
            <th>Source Type</th>
            <th>Order Id</th>
            <th>Order DID</th>
            <th>Service Type</th>
            <!--<th>Service At</th>-->
            <!--<th>Location</th>-->
            <th>Order Created Date</th>
            <th>Preferred Date/Time</th>
            <!--<th>Center Assigned Date</th>-->
			      <th>Corporate Name</th>
            <!--<th>Client Org Name</th>-->
            <th>Vendor Name</th>
            <th class="ord_sts">Order Status</th>
            <!-- <th class="ord_sts">Reports</th> -->
            <th>Payment Status</th>
            <!-- <th>Enter OTP</th> -->
            <th>Actions &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
            <!-- <th>Order Details &nbsp;&nbsp; Order History</th> -->
            <!-- <th *ngIf="isTrack">Order History</th> -->
          </tr>
        </thead>
        <tbody>
          <!-- "let orderDetailsObj of orderDetailsRes /*| slice: (page-1) * pageSize : (page-1) * pageSize + pageSize -->
          <tr *ngFor="let orderDetailsObj of orderDetailsRes;let i = index">

            <td>{{orderDetailsObj.order.patientinfo.mrn}}</td>
            <td>{{orderDetailsObj.order.patientinfo.name}}</td>
            <td *ngIf="orderDetailsObj.channel == 1"> Customer portal</td>
            <td *ngIf="orderDetailsObj.channel == 2"> Call center</td>
            <td *ngIf="orderDetailsObj.channel == 3"> Android App</td>
            <td *ngIf="orderDetailsObj.channel == 4"> Corporate Portal</td>
            <td *ngIf="orderDetailsObj.channel == 5"> IOS App</td>
            <td *ngIf="orderDetailsObj.channel == 7"> Officer App</td>
            <td *ngIf="orderDetailsObj.channel == 8"> Kiosk</td>
            <td *ngIf="orderDetailsObj.channel == 12"> OPD</td><!--opd_c-->
            <td>{{orderDetailsObj.order.patientinfo.order_id}}</td>
            <td>{{orderDetailsObj.order.order_status.order_did}}</td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '3'">Pathology<span *ngIf="orderDetailsObj.order.business.isUCDOrder !=undefined && orderDetailsObj.order.business.isUCDOrder ==1 ">-UCD</span><br/>
            <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">Plateform</span>
            </td>
             <!-- <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '3'">Pathology<span *ngIf="orderDetailsObj.order.business.">-UCD</span></td> -->

            <!-- <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '4'">Radiology<span *ngIf="orderDetailsObj.order.business.">-UCD</span></td> --> 
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '4'">Radiology<span *ngIf="orderDetailsObj.order.business.isUCDOrder !=undefined && orderDetailsObj.order.business.isUCDOrder ==1">-UCD</span><br/>
            <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">Plateform</span>
            </td> 

            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '1'">
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">OPD Consultation</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">Online Consultation</span>
              </td> <!--opd_c-->

              <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '2'">Medicines<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">Plateform</span>
              </td>

            <!--<td *ngIf="orderDetailsObj.mode_of_service == 1">Home</td>
            <td *ngIf="orderDetailsObj.mode_of_service == 2">Center</td>
            <td *ngIf="orderDetailsObj.mode_of_service == 3">Plateform</td>-->
            <!--<td>{{orderDetailsObj.order.patientinfo.city}}</td>-->
            <td>{{orderDetailsObj.order.order_status.created_date | date:'dd/MM/yyyy hh:mm a'}}</td>
            <!--<td>{{orderDetailsObj.order.patientinfo.scheduled_date | date:'dd/MM/yyyy hh:mm a':'UTC'}}</td>-->
            <td>{{orderDetailsObj.order.patientinfo.preferred_time| date:'dd/MM/yyyy hh:mm a'}}</td>
            <td>{{orderDetailsObj.order.patientinfo.corporatename}}</td>
			      <!--<td>{{getTenantNameBycode(orderDetailsObj.tenantCode)}}</td>
            <td>{{getOrgNameByCode(orderDetailsObj.orgCode)}}</td>-->
            <td>

              <app-diagnostic-center-address [providerInfoObj]="orderDetailsObj.order"></app-diagnostic-center-address>

            </td>
            <td>{{orderDetailsObj.data.Nomenclature}}</td>
            <!-- <td *ngIf="role!= 97 ||(role==97 && orderDetailsObj.order.business.isUCDOrder == 1)"(click)="loadReports(orderDetailsObj.order)"><a>Upload</a></td>  -->

            <!-- <td (click)="loadReports(orderDetailsObj.order)"><a>Upload</a></td> -->
            <!-- <td>
              <app-report-upload-link [role]="role" [orderDetailsObj]="orderDetailsObj"></app-report-upload-link>
            </td> -->
            <td *ngIf="orderDetailsObj.payment_info.payable_amount<=0">Prepaid</td>
            <td *ngIf="orderDetailsObj.payment_info.payable_amount>0">Pending for Payment</td>
            <!-- <td>
              <div *ngIf="orderDetailsObj.OStatus != 26">
                <input type="text" class="form-control col-form-label-sm" placeholder=""
                  (blur)="verifyOtpRequestInfo(orderDetailsObj,i)" id="verifyOtp{{i}}">
              </div>
              <div *ngIf="orderDetailsObj.OStatus == 26">Verified</div>
            </td> -->
            
            <td class="view_btn" >
              <img class="exitImg" src="./assets/img/eye.png" (click)="getOrderById(orderDetailsObj.order.patientinfo.order_id)"  ngbTooltip="View Details">&nbsp; 
              <img class="exitImg" src="./assets/img/info.png"
                (click)="opentrackOrderModal(orderDetailsObj.order.patientinfo.order_id)"  ngbTooltip="Track History" *ngIf="isTrack"/>
            </td>
            <!--<td class="view_btn" (click)="opentrackOrderModal(orderDetailsObj.order.patientinfo.order_id)" *ngIf="isTrack">Track</td>-->
            
            <!-- <td>
              <img class="exitImg" src="./assets/img/share-square-solid-blue.png"
                (click)="opentrackOrderModal(orderDetailsObj.order.patientinfo.order_id)" *ngIf="isTrack"/> 
              </td> -->
          </tr>

        </tbody>
      </table>

    </div>
    <!--<div *ngIf="isOrderListDataExist"><b>No Records Found</b></div>
    <div class="col-12" *ngIf="orderDetailsRes?.length">

      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5" [boundaryLinks]="true"
        class="d-flex justify-content-end customPagination" (pageChange)="pageChange(page)">
      </ngb-pagination>

    </div>-->
     <div *ngIf="isOrderListDataExist" class="noRecord"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="orderDetailsRes?.length">
      <div class="totalRecords">
        Total Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
    </ngb-pagination>
     </div> 
    </div>

  </div>
<!-- <div *ngIf="!isOrderListDataExist">No Records Found</div> -->
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>

  
</section>